import React from 'react';
import classNames from 'classnames';
import Icon from '../icon';
import DaysView, { alwaysValidDate } from './DaysView';
import { ViewMode } from './enum';
import { FieldType } from '../data-set/enum';
import { stopEvent } from '../_util/EventManager';
export default class MonthsView extends DaysView {
    getViewClassName() {
        const { prefixCls } = this;
        return `${prefixCls}-month`;
    }
    handleKeyDownHome(e) {
        stopEvent(e);
        this.changeCursorDate(this.getCloneDate().startOf('y'));
    }
    handleKeyDownEnd(e) {
        stopEvent(e);
        this.changeCursorDate(this.getCloneDate().endOf('y'));
    }
    handleKeyDownLeft(e) {
        stopEvent(e);
        if (e.altKey) {
            this.changeViewMode(ViewMode.year);
        }
        else {
            this.changeCursorDate(this.getCloneDate().subtract(1, 'M'));
        }
    }
    handleKeyDownRight(e) {
        stopEvent(e);
        if (e.altKey) {
            const { mode } = this.props;
            if (mode !== ViewMode.month) {
                this.changeViewMode(mode);
            }
        }
        else {
            this.changeCursorDate(this.getCloneDate().add(1, 'M'));
        }
    }
    handleKeyDownUp(e) {
        stopEvent(e);
        this.changeCursorDate(this.getCloneDate().subtract(3, 'M'));
    }
    handleKeyDownDown(e) {
        stopEvent(e);
        this.changeCursorDate(this.getCloneDate().add(3, 'M'));
    }
    handleKeyDownPageUp(e) {
        stopEvent(e);
        this.changeCursorDate(this.getCloneDate().subtract(e.altKey ? 10 : 1, 'y'));
    }
    handleKeyDownPageDown(e) {
        stopEvent(e);
        this.changeCursorDate(this.getCloneDate().add(e.altKey ? 10 : 1, 'y'));
    }
    renderHeader() {
        const { prefixCls, props: { date }, } = this;
        return (React.createElement("div", { className: `${prefixCls}-header` },
            React.createElement("a", { className: `${prefixCls}-prev-year`, onClick: this.handlePrevYearClick },
                React.createElement(Icon, { type: "first_page" })),
            React.createElement("a", { className: `${prefixCls}-view-select`, onClick: this.handleYearSelect }, date.year()),
            React.createElement("a", { className: `${prefixCls}-next-year` },
                React.createElement(Icon, { type: "last_page", onClick: this.handleNextYearClick }))));
    }
    renderPanelHead() {
        return undefined;
    }
    renderPanelBody() {
        const { prefixCls, props: { date, renderer = this.renderCell, isValidDate = alwaysValidDate, onDateMouseLeave }, } = this;
        const selected = date.clone();
        const prevMonth = date.clone().startOf('y');
        const lastMonth = prevMonth.clone().add(12, 'M');
        const rows = [];
        let cells = [];
        while (prevMonth.isBefore(lastMonth)) {
            const currentMonth = prevMonth.clone();
            const isDisabled = !isValidDate(currentMonth, selected);
            const className = classNames(`${prefixCls}-cell`, {
                [`${prefixCls}-selected`]: prevMonth.isSame(selected, 'M'),
                [`${prefixCls}-disabled`]: isDisabled,
            });
            const text = prevMonth.localeData().monthsShort(prevMonth);
            const monthProps = {
                key: text,
                className,
                children: this.renderInner(text),
            };
            if (!isDisabled) {
                monthProps.onClick = this.handleCellClick.bind(this, currentMonth);
                monthProps.onMouseEnter = this.handleDateMouseEnter.bind(this, currentMonth);
                monthProps.onMouseLeave = onDateMouseLeave;
            }
            cells.push(renderer(monthProps, text, currentMonth, selected));
            if (cells.length === 3) {
                rows.push(React.createElement("tr", { key: text }, cells));
                cells = [];
            }
            prevMonth.add(1, 'M');
        }
        return rows;
    }
    renderFooter() {
        return undefined;
    }
    getPanelClass() {
        return `${this.prefixCls}-month-panel`;
    }
    choose(date) {
        const { mode } = this.props;
        if (mode !== ViewMode.month) {
            this.changeCursorDate(date);
            this.changeViewMode(mode);
        }
        else {
            super.choose(date);
        }
    }
}
MonthsView.displayName = 'MonthsView';
MonthsView.type = FieldType.month;
